export const routeBlackList = ["/neurapulse"];